import moment from 'moment';
import isNil from 'lodash/isNil';
import { escapeHtml } from 'utils/security';

function formatDurationMins(minutes) {
  const total = Math.round(minutes);
  const mins = total % 60;
  const hours = (total - mins) / 60;
  if (hours > 0 && mins > 0) return `${hours}h ${mins}m`;
  if (hours > 0) return `${hours}h`;
  if (mins > 0) return `${mins}m`;
  return null;
}

export function createStopPopup(data, translations) {
  const {
    arr_time: arrival,
    dep_time: departure,
    jobTags = [],
    address,
    labels,
    territory,
    pudoGroupId,
    position,
    skills,
    categories,
    priority,
    load,
    types = [],
    jobIds = [],
    chargeKwh,
    batteryCapacity,
    consumption,
    parkingId,
  } = data;

  const {
    map: {
      arrivalJobMarkerTrans,
      departureJobMarkerTrans,
      territoryMarkerTrans,
      skillsMarkerTrans,
      groupMarkerTrans,
      categories: categoriesTrans,
      priorityTrans,
      load: loadTrans,
      duration: durationTrans,
      position: positionTrans,
      batteryChargeTrans,
      consumptionTrans,
      parkingId: parkingIdTrans,
      stationIdTrans,
    },
  } = translations;

  const isPudo = types.length === 1 && types[0] === 'pudo';
  const isRecharge = types.length === 1 && types[0] === 'recharge';

  const addressLabel = address ? `${escapeHtml(address)}<br/>` : '';
  const labelsLabel = labels ? labels.map(escapeHtml).join('<br/>') : '';
  const title = `<div style="color: #000; font-weight: bold; margin-bottom: 0.5rem; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">${addressLabel}${labelsLabel}</div>`;

  const filteredTags = jobTags.filter((tag) => !isNil(tag));
  const tagsRow =
    filteredTags.length > 0
      ? `<tr><td>Tags:</td><td>${filteredTags.map(escapeHtml).join(', ')}</td></tr>`
      : '';

  const arrivalRow = arrival
    ? `<tr><td>${arrivalJobMarkerTrans}:</td><td>${moment(arrival).format('lll')}</td></tr>`
    : '';

  const departureRow = departure
    ? `<tr><td>${departureJobMarkerTrans}:</td><td>${moment(departure).format('lll')}</td></tr>`
    : '';

  const durationMins =
    arrival && departure ? moment(departure).diff(moment(arrival), 'minutes') : null;
  const formattedDuration =
    durationMins !== null && durationMins > 0 ? formatDurationMins(durationMins) : null;
  const durationRow =
    isPudo && formattedDuration
      ? `<tr><td>${durationTrans}:</td><td>${escapeHtml(formattedDuration)}</td></tr>`
      : '';

  const groupRow =
    isPudo && pudoGroupId && pudoGroupId.length > 0
      ? `<tr><td>${groupMarkerTrans}:</td><td>${pudoGroupId.map(escapeHtml).join(', ')}</td></tr>`
      : '';

  const positionRow =
    isPudo && position && position.length > 0
      ? `<tr><td>${positionTrans}:</td><td>${position.map(escapeHtml).join(', ')}</td></tr>`
      : '';

  const territoryRow = territory
    ? `<tr><td>${territoryMarkerTrans}:</td><td>${escapeHtml(territory.name)}</td></tr>`
    : '';

  const skillsRow =
    skills && skills.length > 0
      ? `<tr><td>${skillsMarkerTrans}:</td><td>${skills.map(escapeHtml).join(', ')}</td></tr>`
      : '';

  const categoriesRow =
    categories && categories.length > 0
      ? `<tr><td>${categoriesTrans}:</td><td>${categories.map(escapeHtml).join(', ')}</td></tr>`
      : '';

  const priorityRow =
    priority && priority.length > 0
      ? `<tr><td>${priorityTrans}:</td><td>${priority.map(escapeHtml).join(', ')}</td></tr>`
      : '';

  const loadRow =
    load && load.length > 0
      ? `<tr><td>${loadTrans}:</td><td>${load.map(escapeHtml).join(', ')}</td></tr>`
      : '';

  const chargePercent =
    chargeKwh != null && batteryCapacity != null && batteryCapacity > 0
      ? Math.round((chargeKwh / batteryCapacity) * 100)
      : null;
  const chargeRow =
    chargePercent != null
      ? `<tr><td title="${escapeHtml(
          batteryChargeTrans,
        )}">${batteryChargeTrans}:</td><td>${chargePercent}%</td></tr>`
      : '';

  const consumptionRow =
    consumption != null
      ? `<tr><td title="${escapeHtml(
          consumptionTrans,
        )}">${consumptionTrans}:</td><td>${consumption}</td></tr>`
      : '';

  const parkingIdRow =
    parkingId && parkingId.length > 0
      ? `<tr><td>${parkingIdTrans}:</td><td>${parkingId.map(escapeHtml).join(', ')}</td></tr>`
      : '';

  const rechargeJobId = jobIds.filter((id) => !isNil(id))[0];
  const stationIdRow =
    isRecharge && rechargeJobId
      ? `<tr><td>${stationIdTrans}:</td><td>${escapeHtml(rechargeJobId)}</td></tr>`
      : '';

  return `${title}
    <table>
      ${tagsRow}
      ${arrivalRow}
      ${departureRow}
      ${durationRow}
      ${groupRow}
      ${positionRow}
      ${territoryRow}
      ${skillsRow}
      ${categoriesRow}
      ${priorityRow}
      ${loadRow}
      ${chargeRow}
      ${consumptionRow}
      ${parkingIdRow}
      ${stationIdRow}
    </table>`;
}
